import Image from "next/image";
import { conditions } from "../../../../../helpers";
import { ConditionName, IPlayPauseIconProps } from "../../../../../interfaces";
import IMAGES from "../../../../../images/importImages";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";

const PlayPauseIcon = (props: IPlayPauseIconProps) => {
    useAppSelector(({ controller: { play } }) => ({ play }), shallowEqual);

    return (
        <Image
            src={conditions(ConditionName.isPlay) ? IMAGES.pause : IMAGES.playWhite}
            alt="play-pause-icon"
            className="pl-cursor-pointer"
            width={18}
            height={18}
            {...props}
        />
    );
};

export default PlayPauseIcon;
